var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-select',_vm._b({attrs:{"options":_vm.listOptions},on:{"change":_vm.triggerChange}},'a-select',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }